module.exports = __webpack_public_path__ + "static/media/User.45efb0de.svg";